import { Map } from 'immutable';
import { actionTypes } from '../../../../controller';

const {
	GET_CONVERSATION_SILENCE,
	RESET_CONVERSATION_SILENCE,
} = actionTypes;
const initialState = Map({
	silenceMessage: '',
});

export default function conversationError(state = initialState, action) {
	switch (action.type) {
		case GET_CONVERSATION_SILENCE:
			return state
				.set('silenceMessage', action.message);

		case RESET_CONVERSATION_SILENCE:
			return state
				.set('silenceMessage', '');

		default:
			return state;
	}
}
